import { useState } from 'react'
import { Box, Typography, Collapse, IconButton } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  messageCell: {
    maxWidth: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  expandedMessage: {
    whiteSpace: 'pre-wrap',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
}))

const ExpandableMessagePanel = ({ record }) => {
  const [expanded, setExpanded] = useState(false)
  const classes = useStyles()
  const isMessageLengthExceeding = record.message && record.message.length > 60

  if (!record) return null

  return (
    <div>
      <Box display='flex' alignItems='center'>
        <Box className={classes.messageCell}>{record.message}</Box>
        {isMessageLengthExceeding && (
          <IconButton
            size='small'
            onClick={(e) => {
              e.stopPropagation()
              setExpanded(!expanded)
            }}
          >
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        )}
      </Box>
      {isMessageLengthExceeding && (
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <Box className={classes.expandedMessage}>{record.message}</Box>
        </Collapse>
      )}
    </div>
  )
}

export default ExpandableMessagePanel
